// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-tag {\n  font-weight: normal; }\n  .ant-tag.ant-tag-blue {\n    border-color: rgba(24, 144, 255, 0.5);\n    color: #1890ff;\n    background: rgba(24, 144, 255, 0.1); }\n  .ant-tag.ant-tag-red {\n    background: #ffebeb; }\n\n.ant-tag-error {\n  background: #fff1f0;\n  color: #f5222d;\n  border-color: #ffa39e; }\n\n.Tag_wrapper__3yBSz.Tag_large__3uzlx {\n  padding: 5px 16px;\n  font-size: 14px; }\n\n.Tag_wrapper__3yBSz .anticon {\n  margin-right: 4px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "Tag_wrapper__3yBSz",
	"large": "Tag_large__3uzlx"
};
module.exports = exports;
